import * as ActionTypes from "./ActionTypes";

export const BUS = (state = { busesarray: [] }, action) => {
  switch (action.type) {
    case ActionTypes.ADD_BUSES:
      return { ...state, busesarray: action.payload };

    default:
      return state;
  }
};
